
import { computed, defineComponent, PropType, reactive, ref, watch } from 'vue'
import { CtSupplier } from '@/models/interfaces/content-type'
import EditableBlock from '@/components/EditableBlock.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import DButton from '@/components/base/DButton.vue'
import AddIcon from '@/components/Icons/AddIcon.vue'

export default defineComponent({
  name: 'SupplierBillingAddress',
  components: { EditableBlockInput, EditableBlock, DButton, AddIcon },
  props: {
    supplier: {
      type: Object as PropType<CtSupplier>,
      required: true,
    },
  },
  emits: ['update:supplier'],
  setup (props) {
    const editing = ref(false)

    const billingAddress = ref(props.supplier.billing_address ?? {})

    watch(() => props.supplier, () => {
      billingAddress.value = props.supplier.billing_address ?? {}
    })

    const showFields = computed(
      () => Object.values(billingAddress.value).filter(f => !!f).length || editing.value
    )

    return {
      editing,
      billingAddress,
      showFields,
    }
  }
})
